import { useEffect } from 'react';
import { useLocalStorage, useMediaQuery } from 'usehooks-ts';

export const themeOptions = ['system', 'light', 'dark'];

// Follows the OS preference until the user picks a theme; brand-tokens.css
// reacts to the `dark` / `dark-theme` classes on <html>.
export const useBrandTheme = () => {
  const [theme, setTheme] = useLocalStorage('musicstyling.theme', 'system');
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const isDark = theme === 'dark' || (theme !== 'light' && prefersDark);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    document.documentElement.classList.toggle('dark-theme', isDark);
  }, [isDark]);

  return { theme, setTheme, isDark };
};
